export default "__VITE_ASSET__NU$VW7wo__"